import React, {useState} from 'react';
import Select from '../Select.jsx';
import {closeModal, Modal as ModalComponent} from '../Modal.jsx';
import {Portal} from '../Portal.jsx';
import ManageOrganizationHierarchyGrid from '../../programme_organization_unit/ManageOrganizationHierarchyGrid.jsx';

import {
  common_user_organisation_tree_options_path,
} from '~/routes'

const MODAL_ID = 'organisation-tree-picker-modal';

const OrganisationTreePickerModal = ({handleCloseModal, handleItemSelect, excludeUserTypes}) => {

  const handleClose = () => {
    closeModal(MODAL_ID);
    handleCloseModal()
  };

  const handleOnSelect = (item) => {
    handleItemSelect(item)
    handleClose();
  };

  return (
    <Portal
      id={MODAL_ID}
      size='xl'
      title={I18n.t('select_user')}
      onClose={handleClose}
      hideSaveButton={true}
      cancelLabel={I18n.t('close')}
      cssClassNameCancelButton="pull-right"
      component={ModalComponent}
    >
      <ManageOrganizationHierarchyGrid
        useAsPicker={{
          enabled: true,
          url: common_user_organisation_tree_options_path({exclude_user_types: excludeUserTypes}),
          onSelect: handleOnSelect
        }}
      />
    </Portal>
  );
};

function UserOrganisationTreePicker({
  name,
  value,
  label,
  placeholder,
  onChange = () => {},
  isDisabled = false,
  isClearable = false,
  readOnly = false,
  excludeUserTypes = []
}) {
  const [openModal, setOpenModal] = useState(false);
  const [options, setOptions] = useState(value ? [{value: value, label: label}] : []);

  const handleCloseModal = () => setOpenModal(false);
  const handleSelectFocus = () => setOpenModal(true);

  const handleItemSelect = (item) => {
    var {label, value} = item;
    label = label.replace(/\s*\(.*?\)/g, ''); // Extract name from label

    const option = {label, value: `${value}-user`}
    setOptions([option])
    onChange && onChange(option);
  };

  return (
    <>
      <Select
        name={name}
        value={options?.[0]?.value}
        options={options}
        placeholder={placeholder}
        onFocus={handleSelectFocus}
        onChange={handleItemSelect}
        className={`react-select-bootstrap ${isDisabled && "disabled"}  ${readOnly && "readonly"}`}
        isDisabled={isDisabled || readOnly}
        isClearable={isClearable}
        menuIsOpen={false}
      />
      {openModal && <OrganisationTreePickerModal {...{handleCloseModal, handleItemSelect, excludeUserTypes}}/>}
    </>
  )
}

export default UserOrganisationTreePicker;
